import React from 'react';
import styled from 'styled-components';
import { canSettleClearing } from '../../../../../admin/authorities';
import { openAlertModal } from '../../../../actions/alert-modal';
import { useAppDispatch, useAppSelector } from '../../../../hooks/useApp';
import FA from '../../../atoms/FontAwesome';

type Props = {
  isSettled: boolean;
  clearingId: string;
  onFinishClearing: (id: string) => void;
};

// 精算状態セルの共通ピル形状（旧 ClearingDropdown の見た目を踏襲）。
const pill = `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 2px 10px;
  font-size: 0.875rem;
  white-space: nowrap;
`;

// 未精算→精算済は一方向（不可逆）の操作。状態は二値なので「選択」ではなく
// 単一アクションのボタンにする（旧 UI のドロップダウン選択＝冗長な中間ステップを廃止）。
const SettleButton = styled.button`
  ${pill}
  color: #008800;
  border: 1px solid #008800;
  background: #ffffff;
  cursor: pointer;

  &:hover {
    background: #f1f8f1;
  }
`;

const SettledLabel = styled.span`
  ${pill}
  color: #888888;
  border: 1px solid #888888;
`;

const PendingLabel = styled.span`
  ${pill}
  color: #008800;
  border: 1px solid #008800;
`;

const ModalWarningMessage = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: center;

  p {
    margin-bottom: 0;
    color: #d75f48;
  }
`;

const Icon = styled(FA)`
  font-size: 16px;
`;

const ClearingSettleButton = ({ isSettled, clearingId, onFinishClearing }: Props) => {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.user);

  // 精算状態の変更は発行体の管理者のみ（加盟事業者は閲覧のみ）。
  const isIssuer = () => canSettleClearing(user);

  // 不可逆操作のため確認モーダルは残す（これはミス予防であって冗長ステップではない）。
  const confirmSettle = () => {
    dispatch(
      openAlertModal({
        body: (
          <div>
            <p>この精算データを精算済みにします。</p>
            <ModalWarningMessage>
              <Icon icon="exclamation-triangle" color="#D75F48" />
              <p>この操作は取り消せません</p>
            </ModalWarningMessage>
          </div>
        ),
        confirmText: '精算済にする',
        cancelText: 'キャンセル',
        confirmColor: 'danger',
        onConfirm: () => onFinishClearing(clearingId),
      })
    );
  };

  if (isSettled) return <SettledLabel>精算済</SettledLabel>;
  if (!isIssuer()) return <PendingLabel>未精算</PendingLabel>;

  return (
    <SettleButton type="button" onClick={confirmSettle}>
      精算済にする
    </SettleButton>
  );
};

export default ClearingSettleButton;
